import React from 'react';
import Section from '../ui/Section';
import Button from '../ui/Button';
import { motion } from 'framer-motion';

const PathwaySection = () => {
  const pathways = [
    { 
      situation: "We're just getting started", 
      description: "Learn the principles every leader should understand before using AI across their organisation.",
      action: "Download the Guide",
      link: '/resources/guide',
      variant: 'outline'
    },
    { 
      situation: "We're already using AI", 
      description: "Find out how prepared your organisation is to lead AI with confidence and integrity.",
      action: "Take the AI Leadership Health Check",
      link: '/assessment',
      variant: 'primary'
    }
  ];

  return (
    <Section bg="cream" className="py-24">
      <div className="text-center mb-16 px-4">
        <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-4">Start your AI leadership journey</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto px-4">
        {pathways.map((path, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col h-full transform transition-all hover:shadow-xl group"
          >
            <h3 className="text-2xl md:text-3xl font-bold text-brand-navy mb-6 group-hover:text-brand-teal transition-colors">"{path.situation}"</h3>
            <p className="text-gray-600 mb-10 flex-grow leading-relaxed text-lg">
              {path.description}
            </p>
            <Button 
              to={path.link} 
              variant={path.variant} 
              fullWidth 
              className="py-5 text-lg font-bold rounded-2xl shadow-sm"
            >
              {path.action}
            </Button>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default PathwaySection;